import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const licenseAccessModuleDisableResultSlice = getBulkActionSlice(
    'licenseAccessModuleDisableResult',
);

export const selectLicenseAccessModuleDisableResultShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.licenseAccessModuleDisableResult.shown;

export const selectLicenseAccessModuleDisableResultTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.licenseAccessModuleDisableResult.backgroundTask;

export const selectLicenseAccessModuleDisableResultUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.licenseAccessModuleDisableResult.uuid;

export const {
    setShown,
    setBackgroundTask,
    clearResult,
    setUuid,
} = licenseAccessModuleDisableResultSlice.actions;
